import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/suppliers'
import Component from 'components/Punchout/SelectSupplier'

export default createListModalContainer({ actions })(Component)
